import { oldUserSchema } from "@api/user/schemas";
import { z } from "zod";

export const groupSchema = z.object({
	uuid: z.string().uuid(),
	name: z.string().min(3).max(70),
	private: z.boolean(),
	author: z.lazy(() => oldUserSchema),
	created_at: z.coerce.date(),
	top_members: z.array(z.lazy(() => oldUserSchema)),
	joined: z.boolean(),
});
